//Step 1
export const SAVE_BROKER = 'SAVE_BROKER';
export const SAVE_TYPEOFCONTRACT = 'SAVE_TYPEOFCONTRACT';
export const SAVE_DATEOFCONTRACT = 'SAVE_DATEOFCONTRACT';
export const SAVE_SUPPLIER = 'SAVE_SUPPLIER';
export const SAVE_SUPPLIERTYPE = 'SAVE_SUPPLIERTYPE';
export const SAVE_YEAR = 'SAVE_YEAR';
export const SAVE_UNITS = 'SAVE_UNITS';
export const SAVE_TRANSPORTTYPE = 'SAVE_TRANSPORTTYPE';
export const SAVE_REMARK = 'SAVE_REMARK';
export const SAVE_CERTINFO = 'SAVE_CERTINFO';
export const SET_VERTSTEP = 'SET_VERTSTEP';
export const SET_HORSTEP = 'SET_HORSTEP';
export const SET_EXTERNALREFCALCULATED = 'SET_EXTERNALREFCALCULATED';
export const SET_EXTERNALREF = 'SET_EXTERNALREF';
export const SET_VALIDUNTILLDATE = 'SET_VALIDUNTILLDATE';
export const SET_DETAILUOM = 'SET_DETAILUOM';
export const SET_DATAAREA= 'SET_DATAAREA';
//Step 2
export const SET_PRODUCT = 'SET_PRODUCT';
export const SET_FROMDATE = 'SET_FROMDATE';
export const SET_TODATE = 'SET_TODATE';
export const SET_QUANTITY = 'SET_QUANTITY';
export const SET_UNIT = 'SET_UNIT';
export const SET_PRICE = 'SET_PRICE';
export const SET_SUPP = 'SET_SUPP';
export const SET_TRANSP = 'SET_TRANSP';
export const ADD_PRODUCTDATA = 'ADD_PRODUCTDATA';
export const REMOVE_PRODUCTDATA = 'REMOVE_PRODUCTDATA';
export const SET_NEWID = 'SET_NEWID';
export const SET_CONTRACTPRICE = 'SET_CONTRACTPRICE';
export const SET_OVERDELIVERY = 'SET_OVERDELIVERY';
export const SET_EDITMODE = 'SET_EDITMODE';
export const SET_EDITID = 'SET_EDITID';
export const EDIT_PRODUCTDATA = 'EDIT_PRODUCTDATA';
export const SET_DELETED = 'SET_DELETED';
export const SET_PRICESCHEMEDIALOGVISIBLE = 'SET_PRICESCHEMEDIALOGVISIBLE';
//Step 3
export const SET_DIALOGSTATE = 'SET_DIALOGSTATE';
export const ADD_CONTRACT = 'ADD_CONTRACT';
export const RESET_FORM = 'RESET_FORM';
export const SET_EXTERNALREFID = 'SET_EXTERNALREFID';
export const SAVE_SELECTEDFREECLAUSES = 'SAVE_SELECTEDFREECLAUSES';
//Overview
export const SET_EDITCONTRACTMODE = 'SET_EDITCONTRACTMODE';
export const SET_EDITCONTRACTID = 'SET_EDITCONTRACTID';
export const SET_EDITCONTRACTDATA = 'SET_EDITCONTRACTDATA';
export const EDITCONTRACT = 'EDITCONTRACT';
export const SET_PURCHASEORDERLINES = 'SET_PURCHASEORDERLINES';
//Settings
export const EDIT_REF = 'EDIT_REF';
